<div class="row">
  <div class="dashboard-container">
    <div class="dashboard-header">
      <h1>Dashboard do Sistema</h1>
      <p class="dashboard-subtitle">Visão geral das informações do sistema</p>
    </div>

    <div class="dashboard-content">
      <div class="info-card">
        <div class="info-card-header">
          <fa-icon [icon]="faInfoCircle" class="icon"></fa-icon>
          <h2>Informações Indisponíveis</h2>
        </div>
        <div class="info-card-body">
          <p>
            No momento não há informações disponíveis para montagem do
            dashboard.
          </p>
        </div>
      </div>

      <div class="placeholder-cards">
        <div class="placeholder-card">
          <div class="placeholder-header">
            <fa-icon [icon]="faChartBar" class="icon"></fa-icon>
            <h3>Relatórios</h3>
          </div>
          <div class="placeholder-content">
            <p>Sem dados suficientes</p>
          </div>
        </div>

        <div class="placeholder-card">
          <div class="placeholder-header">
            <fa-icon [icon]="faChartLine" class="icon"></fa-icon>
            <h3>Métricas</h3>
          </div>
          <div class="placeholder-content">
            <p>Sem dados suficientes</p>
          </div>
        </div>

        <div class="placeholder-card">
          <div class="placeholder-header">
            <fa-icon [icon]="faUsers" class="icon"></fa-icon>
            <h3>Usuários</h3>
          </div>
          <div class="placeholder-content">
            <p>Sem dados suficientes</p>
          </div>
        </div>

        <div class="placeholder-card">
          <div class="placeholder-header">
            <fa-icon [icon]="faCog" class="icon"></fa-icon>
            <h3>Sistema</h3>
          </div>
          <div class="placeholder-content">
            <p>Sem dados suficientes</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
